import { printConstants } from "../../constants";

const defaultState = {
  loading: false,
  error: null,
};

export const printReducer = function (state = defaultState, action) {
  switch (action.type) {
    case printConstants.GETPRINT_REQUEST:
      return {
        loading: true,
        error: null,
      };
    case printConstants.GETPRINT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case printConstants.GETPRINT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};
